window.gsap = require('gsap').gsap;
window.ScrollTrigger = require('gsap/ScrollTrigger').ScrollTrigger;

$(function () {
	$(window).scroll(function() {
		var scrollBottom = $(window).scrollTop() + $(window).height();
		var win_half_height = ($(window).height() / 2);
		var container = $('.animation-container')
			.filter(function(index) {
				if((($(window).scrollTop() + win_half_height) > $(this).offset().top) && (($(this).offset().top + $(this).outerHeight(true)) > $(window).scrollTop()) ) {
					return true;
				}
			});
		container.find('.fadein-item').each(function() {
			if(!$(this).hasClass('active')) {
				$(this).addClass('active');
			}
		});
	});

	$(".core-value-slider.desktop-show").owlCarousel({
		loop: true,
		margin: 0,
		responsiveClass:true,
		dots: true,
		autoplay: false,
		autoplayTimeout: 8000,
		responsive:{
			0:{
	            items:1,
	            nav:true
	        }
		}
	});

	$(".core-value-slider.mobile-show").owlCarousel({
		loop: true,
		margin: 0,
		responsiveClass:true,
		dots: true,
		autoplay: false,
		autoplayTimeout: 8000,
		responsive:{
			0:{
	            items:1,
	            nav:true
	        }
		}
	});

	gsap.config({ nullTargetWarn: false });
	gsap.registerPlugin(ScrollTrigger);
	gsap.to('#what-we-do-top .content-overlay', {
    	width: '100%', 
    	height: '100%',
    	scrollTrigger: {
	    	trigger: '#what-we-do-top',
	    	start: 'top+=200 top+=150',
	    	end: 'bottom-=80 center',
	    	scrub: true,
	    }
	});

	if($(window).width() < 991) {
		gsap.to('#awards-showcase-section .a_m_award .overlay-desc', {
	    	scrollTrigger: {
		    	trigger: '#awards-showcase-section .a_m_award .overlay-desc',
		    	start: 'top-=100 top+=150',
		    	end: 'bottom+=250 center',
		    	once: false,
		    	toggleClass: "active",
		    }
		});
		gsap.to('#awards-showcase-section .data_driven_award .overlay-desc', {
	    	scrollTrigger: {
		    	trigger: '#awards-showcase-section .data_driven_award .overlay-desc',
		    	start: 'top-=100 top+=150',
		    	end: 'bottom+=250 center',
		    	once: false,
		    	toggleClass: "active",
		    }
		});
		gsap.to('#awards-showcase-section .adv_marketing_award .overlay-desc', {
	    	scrollTrigger: {
		    	trigger: '#awards-showcase-section .adv_marketing_award .overlay-desc',
		    	start: 'top-=100 top+=150',
		    	end: 'bottom+=250 center',
		    	once: false,
		    	toggleClass: "active",
		    }
		});

		gsap.to('#awards-showcase-section .performance_marketing_award .overlay-desc', {
	    	scrollTrigger: {
		    	trigger: '#awards-showcase-section .performance_marketing_award .overlay-desc',
		    	start: 'top-=100 top+=150',
		    	end: 'bottom+=250 center',
		    	once: false,
		    	toggleClass: "active",
		    }
		});
	}
		

	function toggleClassActive(elm_class) {
		console.log(elm_class);
		$(elm_class + ' .overlay-desc').toggleClass('active');
	}
});	